const ALLOWED_TAGS = new Set(["B", "STRONG", "I", "EM", "U", "UL", "OL", "LI", "BR", "P", "DIV"]);

const appendSanitizedNode = (sourceNode: Node, targetNode: Node) => {
    if (sourceNode.nodeType === Node.TEXT_NODE) {
        targetNode.appendChild(document.createTextNode(sourceNode.textContent || ""));
        return;
    }

    if (sourceNode.nodeType !== Node.ELEMENT_NODE) {
        return;
    }

    const sourceElement = sourceNode as HTMLElement;
    const tagName = sourceElement.tagName.toUpperCase();

    if (!ALLOWED_TAGS.has(tagName)) {
        sourceElement.childNodes.forEach((childNode) => {
            appendSanitizedNode(childNode, targetNode);
        });
        return;
    }

    const sanitizedElement = document.createElement(tagName.toLowerCase());
    sourceElement.childNodes.forEach((childNode) => {
        appendSanitizedNode(childNode, sanitizedElement);
    });
    targetNode.appendChild(sanitizedElement);
};

const createSanitizedFragment = (html: string) => {
    const parser = new DOMParser();
    const documentFragment = document.createDocumentFragment();
    const parsedDocument = parser.parseFromString(html, "text/html");

    parsedDocument.body.childNodes.forEach((childNode) => {
        appendSanitizedNode(childNode, documentFragment);
    });

    return documentFragment;
};

export const sanitizeRichTextHtml = (html: string) => {
    const container = document.createElement("div");
    container.appendChild(createSanitizedFragment(html));
    return container.innerHTML;
};

export const setSanitizedRichTextContent = (element: HTMLElement, html: string) => {
    element.replaceChildren(createSanitizedFragment(html));
};
